import { useEvaluationHistory } from './evaluationHistoryAtoms';
import { useQueryClient } from '@tanstack/react-query';
import { Evaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { useUpdateEvaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/evaluations/useUpdateEvaluation';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

export function useRedoEvaluation(
  carnetDeNotesId: string,
  evaluationId: string,
) {
  const { past, setPast, future, setFuture, isFutureEmpty } =
    useEvaluationHistory(evaluationId);
  const updateEvaluation = useUpdateEvaluation(
    carnetDeNotesId,
    evaluationId,
    true,
  );
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();

  return () => {
    if (isFutureEmpty) {
      return Promise.resolve();
    }

    const evaluation = queryClient.getQueryData<Evaluation>(
      cdnKeys.cdnEvaluationDetails(
        schoolyear.id,
        school.id,
        carnetDeNotesId,
        evaluationId,
      ),
    );

    const [firstItem, ...restFuture] = future;
    setFuture(restFuture);

    if (evaluation) {
      setPast([...past, evaluation]);
    }

    return updateEvaluation.update(firstItem);
  };
}
